import React from 'react';
import { RouteComponentProps } from 'react-router';

import { JobPostingContainer } from '@/components/job-posting';

type Props = RouteComponentProps<{ slug: string }>;

export const JobDetailPage: React.FC<Props> = ({ match }) => <JobPostingContainer slug={match.params.slug} />;
